import '@cosmos/toast'
import ToastUtils from '@cosmos/toast/utils'
import i18n from 'i18next'

import { Imessage } from './interfaces'

function sameMsg(list, msg) {
  return list?._toasts.some(({ message }) => message === msg)
}

export function toast({ message, type, position }: Imessage) {
  const hotToast = document.querySelector('hot-toast')
  const customPosition = position ? position : 'top right'

  let customType = type
  let customMsg = message

  if (type === 'error-label') {
    customMsg = i18n.t(message)
    customType = 'danger'
  }

  if (hotToast && sameMsg(hotToast as any, customMsg)) {
    return
  }

  ToastUtils[customType]({
    message: customMsg,
    position: customPosition
  })
}
